import React from 'react'
import Header from './Header/Header'
import convert from 'htmr'
import { useIntl } from 'react-intl'

type Props = {
  heading: { id: string; defaultMessage?: string } | string
  stickyHeader: boolean
  blog?: boolean
  loading?: boolean
  children?: React.ReactNode
}

const SubPageHeader = ({
  loading = false,
  stickyHeader = true,
  heading,
  children,
}: Props) => {
  const intl = useIntl()

  return (
    <div className="c-sub-page-header">
      <Header sticky={stickyHeader} translated={false} />
      <div className="o-width-limiter o-width-limiter--full">
        {!loading && (
          <div>
            <h1 className="c-sub-page-header__heading">
              <span className="c-sub-page-header__heading-text">
                {typeof heading === 'object'
                  ? intl.formatMessage(heading)
                  : convert(heading)}
              </span>
            </h1>
            {children}
          </div>
        )}
        {loading && (
          <img
            className="c-loader  c-sub-page-header__loading"
            src={require('media/loader.gif')}
            alt="Loading…"
            width="55"
            height="55"
          />
        )}
      </div>
    </div>
  )
}

export default SubPageHeader
